import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import CMSService from "@/services/CMSService.js";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            pageTitle: "",
            pageContent: ""
        };
    },
    metaInfo() {
        return {
            title: `Política de privacidad de YourDictionary`,
            meta: [
                {
                    name: "description",
                    content: `Página de la política de privacidad de YourDictionary`
                }
            ]
        };
    },
    methods: {
        fetchContent() {
            CMSService.getPrivacidadYDR().then(
                response => {
                    const data = response.data.data;
                    this.pageTitle = data.title;
                    this.pageContent = data.body;
                },
                err => {
                    this.status.err = true;
                }
            );
        }
    },
    mounted() {
        this.fetchContent();
    }
};



// WEBPACK FOOTER //
// ./src/pages/PoliticaDePrivacidad/PoliticaDePrivacidad.js